import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./SaveChangesFooter.module.scss";

interface Props {
  onSave?: () => void;
  onUndo?: () => void;
  saving?: boolean;
  visible?: boolean;
}

const SaveChangesFooter: React.FC<Props> = ({ onSave, onUndo, saving, visible }) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, { [styles.visible]: visible })}>
      <Button loading={saving} onClick={onSave} size="large" type="primary">
        {intl.formatMessage({
          id: "recordPane.saveChangesFooter.saveButton",
          defaultMessage: "Save Changes",
          description: "Floating save button label",
        })}
      </Button>
      <Button disabled={saving} onClick={onUndo} size="large" type="text">
        {intl.formatMessage({
          id: "recordPane.saveChangesFooter.undoButton",
          defaultMessage: "Undo",
          description: "Floating undo button label",
        })}
      </Button>
    </div>
  );
};

export default SaveChangesFooter;
